import Vue from 'vue'
import {namespace} from 'vuex-class'

// @ts-ignore
import {TICKET_MODULE_NAMESPACE} from '@/store/ticket'
import {ITicket} from '../../../../models/ticket'
import {TICKET_SET_APPOINTMENT_BY_FIELD, TICKET_ASSIGN_ME} from '../../../../store/ticket'
import {isNullOrUndefined} from 'util'
import {TicketTypes} from '../../../../common/enums'

const TicketStore = namespace(TICKET_MODULE_NAMESPACE)

export class TicketViewmodel extends Vue {
  dtIsNotifyOwner: boolean;
  dtIsInternal: boolean;
  dtIsMandate: boolean;
  dtAssignedMe: any[];
  dtCurrentTenant: { apartments: any[], blocks: any[], id: number } | null;
  dtTemporaryTenants: any[] | null;
  dtTemporaryParticipants: any[] | null;
  dtEquipments: any[];

  /**
   *
   */
  constructor () {
    super()
    this.dtIsMandate = false
    this.dtAssignedMe = []
    this.dtIsNotifyOwner = false
    this.dtIsInternal = false
    this.dtCurrentTenant = null
    this.dtTemporaryTenants = []
    this.dtTemporaryParticipants = []
    this.dtEquipments = [];
  }

  @TicketStore.Getter ticket: ITicket;
  @TicketStore.Getter characterProblems: any;
  @TicketStore.Getter equipments: any;

  @TicketStore.Mutation(TICKET_SET_APPOINTMENT_BY_FIELD)
  storeAssignValueForTicket: (payload: { [key: string]: any }) => void;
  @TicketStore.Mutation(TICKET_ASSIGN_ME)
  storeAssignMe: (managerId: number) => void;

  get OriginDemand (): 'call' | 'phone' {
    return this.ticket.origin_demand
  }

  set OriginDemand (value: 'call' | 'phone') {
    this.storeAssignValueForTicket({origin_demand: value})
  }

  get Declarant (): any {
    // return this.ticket.creator
    return this.ticket.declarant
  }

  set Declarant (value: any) {
    const val = value ? value.id : null
    if (isNullOrUndefined(val)) {
      // this.FkTicketApartment = null
      // this.TicketApartments = []
      // this.FkTicketBlock = null
      // this.dtTemporaryTenants = []
      // this.dtTemporaryParticipants = []
      // this.Tenants = []
    }
    // this.storeAssignValueForTicket({creator: val})
    this.storeAssignValueForTicket({declarant: val})
  }

  get Subject (): string {
    return this.ticket.subject
  }

  set Subject (value: string) {
    this.storeAssignValueForTicket({subject: value})
  }

  get pbType (): string {
    return this.ticket.pb_type
  }

  set pbType (value: string) {
    const val: any = {pb_type: value}
    if (value === TicketTypes.Internal) {
      // val.tenants = undefined
    }
    this.storeAssignValueForTicket(val)
  }

  get FkTicketBlock (): number {
    return this.ticket.fk_ticket_block
  }

  set FkTicketBlock (value: number) {
    this.storeAssignValueForTicket({fk_ticket_block: value})
  }

  get mileage (): number {
    return this.ticket.mileage
  }

  set mileage (value: number) {
    this.storeAssignValueForTicket({mileage: value})
  }

  get availability (): string {
    return this.ticket.availability
  }

  set availability (value: string) {
    this.storeAssignValueForTicket({availability: value})
  }

  /*
  get FkTicketApartment (): number {
    return this.ticket.fk_ticket_apartment
  }

  set FkTicketApartment (value: number) {
    this.storeAssignValueForTicket({fk_ticket_apartment: value})
  }
  */

  // New apartments
  get TicketApartments (): number[] {
    return this.ticket.apartments
  }

  set TicketApartments (value: number[]) {
    this.storeAssignValueForTicket({apartments: value})
  }

  get FKTicketCharacterProblem (): number {
    return this.ticket.fk_ticket_character_problem
  }

  set FKTicketCharacterProblem (value: number) {
    this.storeAssignValueForTicket({fk_ticket_character_problem: value})
  }

  get FKTicketCharacterProblem2 (): number {
    return this.ticket.fk_character_problem_level_2
  }

  set FKTicketCharacterProblem2 (value: number) {
    this.storeAssignValueForTicket({fk_character_problem_level_2: value})
  }

  get FKTicketEquipment (): number[] {
    return this.ticket.equipments
  }

  set FKTicketEquipment (value: number[]) {
    if (value && !Array.isArray(value)) {
      this.storeAssignValueForTicket({equipments: [value]})
    } else {
      value.map(x => {
        if (this.dtEquipments.findIndex(y => y.id === x) === -1) {
          this.dtEquipments.push(this.equipments.find(y => y.id === x))
        }
      })
      this.storeAssignValueForTicket({equipments: value || []})
    }
  }

  get Description (): string {
    return this.ticket.description
  }

  set Description (value: string) {
    this.storeAssignValueForTicket({description: value})
  }

  get Managers (): number[] {
    return this.ticket.managers_assigned
  }

  set Managers (value: number[]) {
    this.storeAssignValueForTicket({managers_assigned: value})
  }

  get IsMandate (): boolean {
    return this.dtIsMandate
  }

  set IsMandate (value: boolean) {
    this.dtIsMandate = value
    this.storeAssignValueForTicket({[value ? 'mandates' : 'quotes']: []})
  }

  get Tenants (): number[] {
    return this.ticket.tenants
  }

  set Tenants (value: number[]) {
    // TODO remove
    this.storeAssignValueForTicket({tenants: value})
  }

  // New participants
  get Participants (): any[] {
    return this.ticket.participants
  }

  set Participants (value: any[]) {
    // TODO multi selector
    this.storeAssignValueForTicket({participants: value})
  }

  get MandatesOrQuoteTk (): number[] {
    return this.IsMandate ? this.ticket.mandates : this.ticket.quotes
  }

  set MandatesOrQuoteTk (value: number[]) {
    this.storeAssignValueForTicket({
      mandates: this.IsMandate ? value : null,
      quotes: this.IsMandate ? null : value
    })
  }

  get Caretakers (): number[] {
    return this.ticket.caretakers
  }

  set Caretakers (value: number[]) {
    this.storeAssignValueForTicket({caretakers: value})
  }

  get FKTicketPriorityLevel (): number {
    return this.ticket.fk_ticket_priority
  }

  set FKTicketPriorityLevel (value: number) {
    this.storeAssignValueForTicket({fk_ticket_priority: value})
  }

  get FKTicketSubstatus (): number {
    return this.ticket.fk_ticket_substatus
  }

  set FKTicketSubstatus (value: number) {
    this.storeAssignValueForTicket({fk_ticket_substatus: value})
  }

  get Zones (): number[] {
    return this.ticket.apartment_zone
  }

  set Zones (value: number[]) {
    this.storeAssignValueForTicket({apartment_zone: value})
  }
  /** Computed variables */
  get containerName (): string {
    return this.$i18n.t('TICKET').toString()
  }
}



// WEBPACK FOOTER //
// ./src/containers/ticket/components/ticket-modal-vertical/ticket.viewmodel.ts